import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { CommonService } from '../../../../../../../../../shared/services/common.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProjectsService } from '../../../../../../../core/projects.service';
import { UploadSettingsBidSheetCsvRequest } from '../../../../../../../core/projects.actions';
import * as fromRoot from '../../../../../../../../../state/app.state';
import * as $ from 'jquery';

@Component({
  standalone: false,
  selector: 'app-upload-bid-items',
  templateUrl: './upload-bid-items.component.html',
  styleUrls: ['./upload-bid-items.component.scss'],
})
export class UploadBidItemsComponent implements OnInit, OnDestroy {
  @ViewChild('fileUploadRef') fileUploadRef: ElementRef;

  acceptedFileTypes = [
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'text/csv',
  ];

  file: File | null = null;
  errors: any = null;
  uploading = false;
  private readonly onDestroy = new Subject<void>();

  constructor(
    private store: Store<fromRoot.State>,
    private commonService: CommonService,
    private projectsService: ProjectsService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.projectsService.error
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        if (data) {
          this.uploading = false;
          this.errors = data;
        }
      });
  }

  openFile(id: string): void {
    $(`#${id}`).click();
  }

  handleFileUpload(): void {
    const input = this.fileUploadRef?.nativeElement;
    if (!input?.files?.length) return;
    const selectedFile = input.files[0];
    if (selectedFile) {
      if (!this.acceptedFileTypes.includes(selectedFile.type)) {
        this.commonService.notification('Invalid file type.', 'danger');
        return;
      }
      this.file = selectedFile;
      this.errors = null;
    }
    input.value = '';
  }

  removeSelectedFile(): void {
    this.file = null;
    this.errors = null;
  }

  onSubmit(): void {
    if (!this.file || !this.data?.bidSheetId) {
      this.commonService.notification(
        this.data?.bidSheetId ? 'Please select a file to upload.' : 'Bid sheet not loaded.',
        'danger'
      );
      return;
    }
    this.uploading = true;
    this.errors = null;
    this.store.dispatch(
      UploadSettingsBidSheetCsvRequest({
        payload: {
          projectId: this.data.projectId,
          bidSheetId: this.data.bidSheetId,
          inputFile: this.file,
        },
      })
    );
  }

  getTemplateFile(): void {
    this.commonService.notification('Template download not yet configured.', 'info');
  }

  typeOf(val: any): string {
    return typeof val;
  }

  ngOnDestroy(): void {
    this.onDestroy.next();
    this.onDestroy.complete();
  }
}
